import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import useDrawingsApi from '../hooks/useDrawingsApi';
import PDFViewer from '../../Takeoffs/components/PDFViewer';

export default function DrawingDetailPage() {
  const { id: bidId, pageId } = useParams();
  const navigate = useNavigate();
  const { downloadPage, deletePage } = useDrawingsApi();
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!pageId) return;
    const fetchUrl = async () => {
      try {
        const u = await downloadPage(bidId, pageId);
        setUrl(u);
      } catch (err) {
        console.error(err);
        setError('Failed to load PDF');
      }
    };
    fetchUrl();
  }, [bidId, pageId, downloadPage]);

  const handleClose = () => {
    navigate(`/bids/${bidId}/documents`);
  };

  const handleDelete = async () => {
    if (!window.confirm('Delete this drawing? This action cannot be undone.')) return;
    try {
      await deletePage(bidId, pageId);
      navigate(`/bids/${bidId}/documents`);
    } catch (err) {
      console.error(err);
      setError('Failed to delete drawing');
    }
  };

  return (
    <>
      {url && (
        <PDFViewer
          url={url}
          onClose={handleClose}
          onDelete={handleDelete}
        />
      )}
      {error && <p className="text-red-500 text-center mt-4">{error}</p>}
    </>
  );
}